/**
 * forgotDraft.ts
 * In-memory draft for the forgot-password email, mirroring login/signup drafts.
 * Keeps the typed email across navigation; cleared once the reset link is sent.
 *
 * Backed by the shared `createDraftStore` factory (see utils/draftStore.ts):
 * module-level only — never persisted to disk.
 */

import { createDraftStore } from '../../utils/draftStore';

const store = createDraftStore<string>();

export const getForgotDraft = store.get;
export const setForgotDraft = store.set;
export const clearForgotDraft = store.clear;
